import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DynamicArea.css';
import Editor from '../editor/Editor';
import SpreadSheet from '../spreadsheet/SpreadSheet';
import { placeCard } from '../../helpers/weddingHelper';


class DynamicArea extends Component {
  constructor(...args) {
    super(args);
    this.state = {
      placeCardSubmited: false,
    };
  }

  setDebounce() {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 400);
  }

  canDropImage = () => true

  dropImage = () => {
    this.setDebounce();
  }

  updatePlacecardSubmit = () => {
    this.setState({
      placeCardSubmited: true,
    });
  }

  render() {
    const editorProps = {
      height: 'auto',
      width: '100%',
    };

    const { placeCardSubmited } = this.state;

    const {
      isChange,
      placeholders,
      pages,
      lang,
      backgroundPlaceholders,
      layouts,
    } = this.props;

    const firstLayout = Object.values(layouts).find(() => true);

    if (firstLayout && firstLayout.type === placeCard) {
      if (!placeCardSubmited && Object.values(pages.byId).length === 0) {
        return <SpreadSheet lang={lang} updatePlacecardSubmit={this.updatePlacecardSubmit} />;
      }
    }

    return (
      <div className="DynamicArea">
        <Editor
          {...editorProps}
          canDropImage={this.canDropImage}
          dropImage={this.dropImage}
          isChange={isChange}
          placeholders={placeholders}
          backgroundPlaceholders={backgroundPlaceholders}
          pages={pages}
          lang={lang}
        />
      </div>
    );
  }
}

DynamicArea.defaultProps = {
  placeholders: {},
  dispatch: () => {},
  lang: {},
  layouts: {},
  isChange: false,
  pages: {},
  coverType: '',
  backgroundPlaceholders: {},
};

DynamicArea.propTypes = {
  placeholders: PropTypes.object,
  dispatch: PropTypes.func,
  lang: PropTypes.object,
  layouts: PropTypes.object,
  isChange: PropTypes.bool,
  pages: PropTypes.object,
  coverType: PropTypes.string,
  backgroundPlaceholders: PropTypes.object,
};

export default connect(state => ({
  placeholders: state.entities.placeholders,
  backgroundPlaceholders: state.entities.backgroundPlaceholders,
  pages: state.entities.pages,
  layouts: state.entities.layouts.byId,
  backgroundType: state.editorUI.bookProperties.backgroundType,
}))(DynamicArea);



// WEBPACK FOOTER //
// ./src/components/dynamic-area/DynamicArea.jsx